import {
  AndroidOutlined,
  Apple,
  HelpOutlineOutlined,
  Tablet,
} from "@material-ui/icons";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import {
  Datagrid,
  DateField,
  FunctionField,
  NumberField,
  TextField,
  Record as RaRecord,
  Responsive,
  SimpleList,
} from "react-admin";
import { MobileAppVersionDto } from "../../../common/data/service-proxies";
import { Box, Theme, useTheme, Typography } from "@material-ui/core";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { DeleteRecordMenuItem } from "../../common/data-grid-fields/DeleteRecordMenuItem";

interface Props {}

export const MobileAppVersionsList = (props: Props) => {
  const theme: Theme = useTheme();

  interface SimpleListProps {
    record?: RaRecord;
  }

  const RenderSecondaryTextForSimpleList = ({ record }: SimpleListProps) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          flexWrap: "wrap",
          marginTop: "14px",
        }}>
        <div
          style={{
            display: "flex",
            gap: "6px",
            flexWrap: "wrap",
            alignItems: "center",
          }}>
          <Typography variant="body2" style={{ fontWeight: "600" }}>
            Version:
          </Typography>
          <TextField source="appVersion" label="App version" />
        </div>
        <div
          style={{
            display: "flex",
            gap: "6px",
            flexWrap: "wrap",
            alignItems: "center",
          }}>
          <Typography variant="body2" style={{ fontWeight: "600" }}>
            Build number:
          </Typography>
          <NumberField source="buildNumber" label="Build number" />
        </div>
        <div
          style={{
            display: "flex",
            gap: "6px",
            flexWrap: "wrap",
            alignItems: "center",
          }}>
          <Typography variant="body2" style={{ fontWeight: "600" }}>
            Time added:
          </Typography>
          <DateField source="timestamp" showTime label="Time added" />
        </div>
      </div>
    );
  };

  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={Tablet} />}
        className="content-list"
        title="Mobile app versions"
        bulkActionButtons={false}
        sort={{ field: "timestamp", order: "desc" }}
        {...props}>
        <Responsive
          small={
            <SimpleList
              className="simple-list-wrapper"
              linkType="edit"
              primaryText={(record) => (
                <FunctionField<MobileAppVersionDto & RaRecord>
                  source="mobileAppType"
                  label="OS"
                  render={(record) => (
                    <Box className="mobile-app-container">
                      {record?.mobileApplicationType === "Android" ? (
                        <>
                          <AndroidOutlined
                            style={{
                              color: theme.palette.success.main,
                            }}
                          />
                        </>
                      ) : record?.mobileApplicationType === "AppleIos" ? (
                        <>
                          <Apple
                            style={{
                              color: theme.palette.success.main,
                            }}
                          />
                        </>
                      ) : (
                        <HelpOutlineOutlined
                          style={{
                            color: theme.palette.success.main,
                          }}
                        />
                      )}
                    </Box>
                  )}
                />
              )}
              secondaryText={(record) => (
                <RenderSecondaryTextForSimpleList record={record} />
              )}
              rightIcon={(record) => {
                return (
                  <ActionsField {...props} record={record}>
                    <DeleteRecordMenuItem />
                  </ActionsField>
                );
              }}
            />
          }
          medium={
            <Datagrid>
              <FunctionField<MobileAppVersionDto & RaRecord>
                source="mobileAppType"
                label="OS"
                render={(record) => (
                  <Box className="mobile-app-container">
                    {record?.mobileApplicationType === "Android" ? (
                      <>
                        <AndroidOutlined />
                      </>
                    ) : record?.mobileApplicationType === "AppleIos" ? (
                      <>
                        <Apple />
                      </>
                    ) : (
                      <HelpOutlineOutlined />
                    )}
                  </Box>
                )}
              />
              <TextField source="appVersion" label="App version" />
              <NumberField source="buildNumber" label="Build number" />
              <DateField source="timestamp" showTime label="Time added" />
              <ActionsField>
                <DeleteRecordMenuItem />
              </ActionsField>
            </Datagrid>
          }
        />
      </DefaultProLogsList>
    </div>
  );
};
